<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <h4 class="font-weight-bold">Lazer, Cultura e Esporte</h4>
            </div>
        </div>
        <div class="row">
            <form-select
                grid="6"
                v-model="lazer.participa_atividade_cultural"
                :itens="$root.arrays.pergunta"
                label="Participa de alguma atividade cultural?"
            />
            <form-input
                grid="6"
                v-if="lazer.participa_atividade_cultural == 1"
                v-model="lazer.qual_atividade_participa"
                label="Qual atividade cultural participa?"
            />
            <form-select
                grid="6"
                v-model="lazer.gostaria_participar_atividade"
                :itens="$root.arrays.pergunta"
                label="Gostaria de participar de alguma atividade cultural?"
            />
            <form-input
                grid="6"
                v-if="lazer.gostaria_participar_atividade == 1"
                v-model="lazer.qual_atividade_gostaria_participar"
                label="Qual atividade cultural gostaria de participar?"
            />
            <form-select
                grid="6"
                v-model="lazer.participa_atividade_desportiva"
                :itens="$root.arrays.pergunta"
                label="Participa de alguma atividade desportiva?"
            />
            <form-input
                grid="6"
                v-if="lazer.participa_atividade_desportiva == 1"
                v-model="lazer.qual_atividade_desportiva_participa"
                label="Qual atividade desportiva participa?"
            />
            <form-select
                grid="6"
                v-model="lazer.gostaria_participar_atividade_desportiva"
                :itens="$root.arrays.pergunta"
                label="Gostaria de participar de alguma atividade desportiva?"
            />
            <form-input
                grid="6"
                v-if="lazer.gostaria_participar_atividade_desportiva == 1"
                v-model="lazer.qual_atividade_desportiva_gostaria_participar"
                label="Qual atividade desportiva gostaria de participar?"
            />
            <form-textarea-editor
                v-model="lazer.observacoes"
                label="Observação sobre horas livres (lazer)"
            />
        </div>
        <div class="row pt-2 px-2 d-flex justify-content-end">
            <button @click="submit" class="btn btn-success btn-submit">
                <i class="mdi mdi-content-save"></i>
                Salvar
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            lazer: {},
        };
    },
    mounted() {
        if (this.item.lazer != null) {
            this.lazer = this.item.lazer;
        }
    },
    methods: {
        submit() {
            this.item.lazer = this.lazer;
            this.$emit("submit");
        },
    },
};
</script>
